import { BoxProps } from "@mui/system";
import { FC } from "react";
import * as S from './styles';

export const Section: FC<BoxProps> = ({ children, ...props }) => (
  <S.Section {...props} component="section" className="acova-section">
    {children}
  </S.Section>
);
